import React, { useState } from 'react';
import MainLayout from '../components/MainLayout';
import { useTranslation } from '../context/LanguageContext';
import './MyPage.css';

function MyPage() {
    const { t } = useTranslation();
    const [isEditing, setIsEditing] = useState(false);

    // TODO: API에서 사용자 데이터 가져오기
    const [userData, setUserData] = useState({
        id: 1,
        name: t('pages.myPage.defaultName'),
        email: 'admin@company.net',
        role: t('pages.myPage.defaultRole'),
        department: t('pages.myPage.defaultDepartment'),
        phone: '010-1234-5678',
        joinDate: '2023-01-15',
        lastLogin: '2024-02-01 14:30',
        profileImage: null
    });

    const [passwordData, setPasswordData] = useState({
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setUserData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handlePasswordChange = (e) => {
        const { name, value } = e.target;
        setPasswordData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleEdit = () => {
        setIsEditing(true);
    };

    const handleCancel = () => {
        setIsEditing(false);
        // TODO: 원래 데이터로 복원
        setPasswordData({
            currentPassword: '',
            newPassword: '',
            confirmPassword: ''
        });
    };

    const handleSave = (e) => {
        e.preventDefault();
        // TODO: 사용자 정보 업데이트 API 호출

        setIsEditing(false);
    };

    const handlePasswordUpdate = (e) => {
        e.preventDefault();
        if (passwordData.newPassword !== passwordData.confirmPassword) {
            alert(t('pages.myPage.passwordMismatch'));
            return;
        }
        // TODO: 비밀번호 변경 API 호출

        setPasswordData({
            currentPassword: '',
            newPassword: '',
            confirmPassword: ''
        });
        alert(t('pages.myPage.passwordChanged'));
    };

    const getInitials = (name) => {
        return name.charAt(0);
    };

    return (
        <MainLayout>
            <div className="mypage-container">
                {/* Header Section */}
                <div className="mypage-header">
                    <div className="mypage-header-left">
                        <div className="mypage-title">{t('pages.myPage.title')}</div>
                        <p className="mypage-subtitle">{t('pages.myPage.subtitle')}</p>
                    </div>
                    <div className="mypage-header-right">
                        {!isEditing ? (
                            <button className="mypage-edit-header-btn" onClick={handleEdit}>
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <path d="M11.3333 2C11.5084 1.82493 11.7163 1.68605 11.9457 1.59135C12.1752 1.49665 12.4218 1.44803 12.6707 1.44803C12.9196 1.44803 13.1662 1.49665 13.3956 1.59135C13.6251 1.68605 13.833 1.82493 14.008 2C14.183 2.17507 14.3219 2.38299 14.4166 2.61245C14.5113 2.84191 14.5599 3.08852 14.5599 3.33744C14.5599 3.58636 14.5113 3.83297 14.4166 4.06243C14.3219 4.29189 14.183 4.49981 14.008 4.67488L5.33333 13.3495L1.33333 14.683L2.66667 10.6829L11.3333 2Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                                {t('pages.myPage.editInfo')}
                            </button>
                        ) : (
                            <>
                                <button className="mypage-cancel-header-btn" onClick={handleCancel}>
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                    {t('pages.myPage.cancel')}
                                </button>
                                <button className="mypage-save-header-btn" onClick={handleSave}>
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <path d="M13.3333 4L6 11.3333L2.66667 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                    {t('pages.myPage.save')}
                                </button>
                            </>
                        )}
                    </div>
                </div>

                {/* Content Section */}
                <div className="mypage-content">
                    {/* Profile Card */}
                    <div className="mypage-profile-card">
                        <div className="mypage-profile-avatar-large">
                            {getInitials(userData.name)}
                        </div>
                        <div className="mypage-profile-info">
                            <h2 className="mypage-profile-name">{userData.name}</h2>
                            <p className="mypage-profile-email">{userData.email}</p>
                            <span className="mypage-role-badge">
                                {userData.role}
                            </span>
                        </div>
                        <div className="mypage-profile-meta">
                            <div className="mypage-meta-item">
                                <span className="mypage-meta-label">{t('pages.myPage.joinDate')}</span>
                                <span className="mypage-meta-value">{userData.joinDate}</span>
                            </div>
                            <div className="mypage-meta-item">
                                <span className="mypage-meta-label">{t('pages.myPage.lastLogin')}</span>
                                <span className="mypage-meta-value">{userData.lastLogin}</span>
                            </div>
                        </div>
                    </div>

                    {/* 기본 정보 섹션 */}
                    <form onSubmit={handleSave}>
                        <div className="mypage-section">
                            <h3 className="mypage-section-title">{t('pages.myPage.basicInfo')}</h3>
                            <div className="mypage-grid">
                                <div className="mypage-group">
                                    <label className="mypage-label">{t('pages.myPage.name')}</label>
                                    {isEditing ? (
                                        <input
                                            type="text"
                                            name="name"
                                            className="mypage-input"
                                            value={userData.name}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    ) : (
                                        <div className="mypage-value">{userData.name}</div>
                                    )}
                                </div>

                                <div className="mypage-group">
                                    <label className="mypage-label">{t('pages.myPage.email')}</label>
                                    {isEditing ? (
                                        <input
                                            type="email"
                                            name="email"
                                            className="mypage-input"
                                            value={userData.email}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    ) : (
                                        <div className="mypage-value">{userData.email}</div>
                                    )}
                                </div>

                                <div className="mypage-group">
                                    <label className="mypage-label">{t('pages.myPage.phone')}</label>
                                    {isEditing ? (
                                        <input
                                            type="tel"
                                            name="phone"
                                            className="mypage-input"
                                            value={userData.phone}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    ) : (
                                        <div className="mypage-value">{userData.phone}</div>
                                    )}
                                </div>

                                <div className="mypage-group">
                                    <label className="mypage-label">{t('pages.myPage.department')}</label>
                                    {isEditing ? (
                                        <input
                                            type="text"
                                            name="department"
                                            className="mypage-input"
                                            value={userData.department}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    ) : (
                                        <div className="mypage-value">{userData.department}</div>
                                    )}
                                </div>

                                <div className="mypage-group">
                                    <label className="mypage-label">{t('pages.myPage.role')}</label>
                                    <div className="mypage-value">{userData.role}</div>
                                </div>
                            </div>

                            {isEditing && (
                                <div className="mypage-form-actions">
                                    <button type="button" className="mypage-btn-secondary" onClick={handleCancel}>
                                        {t('pages.myPage.cancel')}
                                    </button>
                                    <button type="submit" className="mypage-btn-primary">
                                        {t('pages.myPage.save')}
                                    </button>
                                </div>
                            )}
                        </div>
                    </form>

                    {/* 비밀번호 변경 섹션 */}
                    <form onSubmit={handlePasswordUpdate}>
                        <div className="mypage-section">
                            <h3 className="mypage-section-title">{t('pages.myPage.changePassword')}</h3>
                            <div className="mypage-grid">
                                <div className="mypage-group">
                                    <label className="mypage-label">{t('pages.myPage.currentPassword')}</label>
                                    <input
                                        type="password"
                                        name="currentPassword"
                                        className="mypage-input"
                                        placeholder={t('pages.myPage.currentPasswordPlaceholder')}
                                        value={passwordData.currentPassword}
                                        onChange={handlePasswordChange}
                                    />
                                </div>

                                <div className="mypage-group">
                                    <label className="mypage-label">{t('pages.myPage.newPassword')}</label>
                                    <input
                                        type="password"
                                        name="newPassword"
                                        className="mypage-input"
                                        placeholder={t('pages.myPage.newPasswordPlaceholder')}
                                        value={passwordData.newPassword}
                                        onChange={handlePasswordChange}
                                        minLength={8}
                                    />
                                </div>

                                <div className="mypage-group">
                                    <label className="mypage-label">{t('pages.myPage.confirmPassword')}</label>
                                    <input
                                        type="password"
                                        name="confirmPassword"
                                        className="mypage-input"
                                        placeholder={t('pages.myPage.confirmPasswordPlaceholder')}
                                        value={passwordData.confirmPassword}
                                        onChange={handlePasswordChange}
                                    />
                                </div>
                            </div>

                            <div className="mypage-form-actions">
                                <button type="submit" className="mypage-btn-primary">
                                    {t('pages.myPage.submitPassword')}
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </MainLayout>
    );
}

export default MyPage;
